module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', {
    staticClass: "main-title grid-container layer1"
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation about layer3"
  }), _vm._v(" "), (_vm.result) ? _c('Carousel', {
    attrs: {
      "classes": "on-home",
      "items": _vm.result
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "main-title grid-container layer1"
  }, [_vm._v("Off Stage")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation off-stage layer2"
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offstage-list-homepage layer1"
  }, [_c('div', {
    staticClass: "grid-container grid-100"
  }, [_c('div', {
    staticClass: "grid-50 push-50 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/233687092",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a7b7854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/About.vue
// module id = 288
// module chunks = 0